import "./Bill.scss";
import { useRef } from "react";

// import axios from "axios";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import BillPrintData from "./BillPrintData";

export default function Bill() {
  const billPrintDataRef = useRef();

  return (
    <>
      <BillPrintData
        // data={"null"}
        ref={billPrintDataRef}
      />

      <div className={"text-center"}>
        <ReactToPrint content={() => billPrintDataRef.current}>
          <PrintContextConsumer>
            {({ handlePrint }) => (
              <button className="btnCustom btnSubmit" onClick={handlePrint}>
                پرینت صورتحساب
              </button>
            )}
          </PrintContextConsumer>
        </ReactToPrint>
      </div>
    </>
  );
}
